/**
 * @generated SignedSource<<d26a7eb79eab7e53829a376646323969>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHeader_home$data = {
  readonly __typename: "Organisation";
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TeamHeader_home";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TeamHeader_home";
};
export type TeamHeader_home$key = {
  readonly " $data"?: TeamHeader_home$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_home">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHeader_home",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "Organisation",
      "abstractKey": null
    }
  ],
  "type": "HomeUnion",
  "abstractKey": "__isHomeUnion"
};

(node as any).hash = "d1386096508d01223f1e1f8c1e62311d";

export default node;
